module.exports = __webpack_public_path__ + "img/1.05716132.jpg";